import Vue from "vue";
import PageView from "./PageView";
import Row from "./Row";
import cCol from "./cCol";
import TitleView from "./TitleView";
import BlockLine from "./BlockLine";
import SmartInput from "./SmartInput";
import MessageBox from "./MessageBox";
import PopupDialog from "./PopupDialog";
import EditBtn from "dev/scaffoldings/EditBtn";
import RemoveBtn from "dev/scaffoldings/RemoveBtn";
import ColsRow from "dev/scaffoldings/ColsRow";

export default {
	PageView,
	Row,
	BlockLine,
	TitleView,
	cCol,
	SmartInput,
	MessageBox,
};

Vue.component("Page", PageView);
Vue.component("Row", Row);
Vue.component("ColsRow", ColsRow);
Vue.component("TitleView", TitleView);
Vue.component("BlockLine", BlockLine);
Vue.component("SmartInput", SmartInput);
Vue.component("CCol", cCol);
Vue.component("MessageBox", MessageBox);
Vue.component("PopupDialog", PopupDialog);
Vue.component("EditBtn", EditBtn);
Vue.component("RemoveBtn", RemoveBtn);
